import React, { Fragment, useState } from 'react';

import { makeStyles } from '@material-ui/core/styles';

import Task from './Task';

const useStyles = makeStyles((theme) => ({
    root: {
    },
    container: {
    },
}));


const Occurrence = ({ item, selectedMode, open, closeEdition, updateValues, dependencies, appointments, openUpload, openDocumentEdition, updateDocuments, openDeletionDocument, openVisitEdition, openDeletionVisit, updateAppointments, updateBudgets, updateExpenses, slas, openActionEdition, openDeletionAction }) => {

    const classes = useStyles();

    return (
        <Fragment>

            <Task item={item}
                selectedMode={selectedMode}
                open={open}
                closeEdition={closeEdition}
                updateValues={updateValues}
                dependencies={dependencies}
                appointments={appointments}
                openUpload={openUpload}
                openDocumentEdition={openDocumentEdition}
                updateDocuments={updateDocuments}
                openDeletionDocument={openDeletionDocument}
                openVisitEdition={openVisitEdition}
                openDeletionVisit={openDeletionVisit}
                updateAppointments={updateAppointments}
                updateBudgets={updateBudgets}
                updateExpenses={updateExpenses}
                slas={slas}
                openActionEdition={openActionEdition}
                openDeletionAction={openDeletionAction}
            />

        </Fragment>
    );
};

export default Occurrence;
